// Re-render the family surface only when the signed-in user actually changes. Supabase fires
// auth events on token refresh and tab re-focus too (e.g. returning from the phone's camera);
// re-rendering on those rebuilds the composer and discards an in-progress capture.
// Regression: a photo taken with the camera was lost on return (2026-08-11).
export function shouldRerender(
  prevUserId: string | null | undefined,
  nextUserId: string | null
): boolean {
  return prevUserId !== nextUserId;
}
